/**
 * =============================================
 * MODAL.JS - Frontend Pre-Checkout Modal
 * =============================================
 * Script embebido en theme.liquid de Shopify.
 * 
 * Funcionalidades:
 * - Intercepta botones "Comprar ahora" y "Agregar al carrito"
 * - Obtiene variant_id del producto actual
 * - Abre modal centrado y responsive
 * - Valida campos del formulario
 * - Envía POST /create-order al backend
 * - Muestra estado de carga
 * - Redirige a página de gracias + WhatsApp
 *
 * CONFIGURACIÓN: Ajusta BACKEND_URL con la URL de tu servidor
 */

(function () {
  'use strict';

  // =============================================
  // CONFIGURACIÓN - AJUSTAR SEGÚN TU SERVIDOR
  // =============================================
  const CONFIG = {
    // ⚠️ IMPORTANTE: Cambia esta URL por la de tu servidor
    // Para pruebas locales usa ngrok: https://abc123.ngrok-free.app
    // Para producción usa tu dominio: https://tu-servidor.com
    BACKEND_URL: 'https://formulario-modal-production.up.railway.app',

    // Número de WhatsApp (con código de país, sin +)
    WHATSAPP_NUMBER: '573001234567',

    // Selectores de botones "Agregar al carrito" a interceptar
    // (El botón "Comprar ahora" de Shopify se maneja por separado abajo)
    BUY_BUTTON_SELECTORS: [
      '[name="add"]',                    // Botón estándar de Shopify
      '.product-form__submit',           // Dawn theme
      '.btn--add-to-cart',               // Debut theme
      'button[type="submit"].product-form__cart-submit',
      '.product__submit__add',
      '#AddToCart',
      '#add-to-cart',
      '.add-to-cart',
      '[data-action="add-to-cart"]'
    ],

    // Selectores para obtener variant_id
    VARIANT_SELECTORS: [
      'input[name="id"]',                // Input hidden estándar de Shopify
      'select[name="id"]',
      '[name="id"]',
      '[data-variant-id]',
      '.product-form__variants select'
    ]
  };

  // =============================================
  // ESTILOS DEL MODAL (inyectados en <head>)
  // =============================================
  const MODAL_STYLES = `
    /* ---- Ocultar el botón Dynamic Checkout de Shopify ("Comprar ahora") ---- */
    /* Lo reemplazamos con nuestro propio botón que podemos controlar */
    .shopify-payment-button,
    .shopify-payment-button__button,
    [data-shopify="payment-button"],
    .product-form__payment-button {
      display: none !important;
    }

    /* ---- Nuestro botón "Comprar ahora" personalizado ---- */
    .modal-buy-now-btn {
      display: block;
      width: 100%;
      padding: 16px;
      background: #25D366; /* WhatsApp Green para generar confianza/baja fricción */
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 700;
      cursor: pointer;
      margin-top: 10px;
      text-align: center;
      font-family: inherit;
      letter-spacing: 0.3px;
      transition: background 0.2s, transform 0.1s;
      box-shadow: 0 4px 12px rgba(37, 211, 102, 0.2);
    }
    .modal-buy-now-btn:hover {
      background: #20b958;
      transform: translateY(-1px);
    }
    .modal-buy-now-btn:active {
      transform: translateY(0);
    }

    /* ---- Overlay ---- */
    #shopify-modal-overlay {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.6);
      z-index: 99999;
      align-items: center;
      justify-content: center;
      padding: 16px;
      backdrop-filter: blur(4px);
      animation: modalFadeIn 0.2s ease;
    }
    #shopify-modal-overlay.active {
      display: flex;
    }
    @keyframes modalFadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }

    /* ---- Contenedor del modal ---- */
    #shopify-modal-box {
      background: #fff;
      border-radius: 16px;
      padding: 32px 28px;
      width: 100%;
      max-width: 460px;
      max-height: 90vh;
      overflow-y: auto;
      position: relative;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
      animation: modalSlideUp 0.25s ease;
    }
    @keyframes modalSlideUp {
      from { transform: translateY(30px); opacity: 0; }
      to   { transform: translateY(0);    opacity: 1; }
    }

    /* ---- Botón cerrar ---- */
    #shopify-modal-close {
      position: absolute;
      top: 14px;
      right: 16px;
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #666;
      line-height: 1;
      padding: 4px 8px;
      border-radius: 6px;
      transition: background 0.2s;
    }
    #shopify-modal-close:hover {
      background: #f0f0f0;
      color: #333;
    }

    /* ---- Título ---- */
    #shopify-modal-box h2 {
      margin: 0 0 6px 0;
      font-size: 20px;
      font-weight: 700;
      color: #1a1a1a;
    }
    #shopify-modal-box .modal-subtitle {
      font-size: 13px;
      color: #666;
      margin: 0 0 24px 0;
    }

    /* ---- Formulario ---- */
    .modal-form-group {
      margin-bottom: 16px;
    }
    .modal-form-group label {
      display: block;
      font-size: 13px;
      font-weight: 600;
      color: #333;
      margin-bottom: 6px;
    }
    .modal-form-group input,
    .modal-form-group select {
      width: 100%;
      padding: 11px 14px;
      border: 1.5px solid #ddd;
      border-radius: 8px;
      font-size: 15px;
      color: #1a1a1a;
      background: #fafafa;
      transition: border-color 0.2s, box-shadow 0.2s;
      box-sizing: border-box;
      outline: none;
      font-family: inherit;
    }
    .modal-form-group input:focus,
    .modal-form-group select:focus {
      border-color: #5c6ac4;
      box-shadow: 0 0 0 3px rgba(92,106,196,0.15);
      background: #fff;
    }
    .modal-form-group input.error,
    .modal-form-group select.error {
      border-color: #e53e3e;
      box-shadow: 0 0 0 3px rgba(229,62,62,0.12);
    }
    .modal-field-error {
      font-size: 12px;
      color: #e53e3e;
      margin-top: 4px;
      display: none;
    }
    .modal-field-error.visible {
      display: block;
    }

    /* ---- Métodos de pago ---- */
    .payment-methods {
      display: flex;
      gap: 10px;
    }
    .payment-method-option {
      flex: 1;
      position: relative;
    }
    .payment-method-option input[type="radio"] {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }
    .payment-method-option label {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 12px 8px;
      border: 2px solid #ddd;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 13px;
      font-weight: 600;
      color: #555;
      background: #fafafa;
      text-align: center;
      gap: 4px;
    }
    .payment-method-option label .payment-icon {
      font-size: 22px;
    }
    .payment-method-option input[type="radio"]:checked + label {
      border-color: #5c6ac4;
      background: #f0f2ff;
      color: #5c6ac4;
    }
    .payment-method-option label:hover {
      border-color: #5c6ac4;
      background: #f8f9ff;
    }

    /* ---- Botón submit ---- */
    #modal-submit-btn {
      width: 100%;
      padding: 14px;
      background: linear-gradient(135deg, #5c6ac4, #4a56b0);
      color: white;
      border: none;
      border-radius: 10px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      margin-top: 8px;
      transition: opacity 0.2s, transform 0.1s;
      font-family: inherit;
      letter-spacing: 0.3px;
    }
    #modal-submit-btn:hover:not(:disabled) {
      opacity: 0.92;
      transform: translateY(-1px);
    }
    #modal-submit-btn:active:not(:disabled) {
      transform: translateY(0);
    }
    #modal-submit-btn:disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }

    /* ---- Loading spinner ---- */
    .modal-loading {
      display: none;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 20px;
      font-size: 14px;
      color: #555;
    }
    .modal-loading.active {
      display: flex;
    }
    .modal-spinner {
      width: 22px;
      height: 22px;
      border: 3px solid #e0e0e0;
      border-top-color: #5c6ac4;
      border-radius: 50%;
      animation: spin 0.7s linear infinite;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    /* ---- Mensaje de error global ---- */
    #modal-error-msg {
      display: none;
      background: #fff5f5;
      border: 1px solid #fed7d7;
      color: #c53030;
      border-radius: 8px;
      padding: 12px 14px;
      font-size: 13px;
      margin-top: 12px;
      line-height: 1.5;
    }
    #modal-error-msg.visible {
      display: block;
    }

    /* ---- Responsive ---- */
    @media (max-width: 480px) {
      #shopify-modal-box {
        padding: 24px 18px;
        border-radius: 12px;
      }
      #shopify-modal-box h2 {
        font-size: 18px;
      }
    }
  `;

  // =============================================
  // HTML DEL MODAL
  // =============================================
  const MODAL_HTML = `
    <div id="shopify-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div id="shopify-modal-box">
        <button id="shopify-modal-close" aria-label="Cerrar modal">&times;</button>

        <h2 id="modal-title">📦 Completa tu pedido</h2>
        <p class="modal-subtitle">Llena el formulario y te contactamos para confirmar la entrega.</p>

        <form id="shopify-modal-form" novalidate>

          <!-- Nombre completo -->
          <div class="modal-form-group">
            <label for="modal-name">Nombre completo *</label>
            <input
              type="text"
              id="modal-name"
              name="customerName"
              placeholder="Ej: María García"
              autocomplete="name"
              maxlength="80"
            />
            <span class="modal-field-error" id="error-name">Ingresa tu nombre completo</span>
          </div>

          <!-- Teléfono -->
          <div class="modal-form-group">
            <label for="modal-phone">Teléfono / WhatsApp *</label>
            <input
              type="tel"
              id="modal-phone"
              name="customerPhone"
              placeholder="Ej: 3001234567"
              autocomplete="tel"
              maxlength="15"
            />
            <span class="modal-field-error" id="error-phone">Ingresa un teléfono válido</span>
          </div>

          <!-- Ciudad -->
          <div class="modal-form-group">
            <label for="modal-city">Ciudad *</label>
            <input
              type="text"
              id="modal-city"
              name="customerCity"
              placeholder="Ej: Bogotá, Medellín, Cali..."
              autocomplete="address-level2"
              maxlength="60"
            />
            <span class="modal-field-error" id="error-city">Ingresa tu ciudad</span>
          </div>

          <!-- Departamento -->
          <div class="modal-form-group">
            <label for="modal-department">Departamento *</label>
            <input
              type="text"
              id="modal-department"
              name="customerDepartment"
              placeholder="Ej: Cundinamarca, Antioquia, Valle..."
              autocomplete="address-level1"
              maxlength="60"
            />
            <span class="modal-field-error" id="error-department">Ingresa tu departamento</span>
          </div>

          <!-- Dirección -->
          <div class="modal-form-group">
            <label for="modal-address">Dirección de entrega *</label>
            <input
              type="text"
              id="modal-address"
              name="customerAddress"
              placeholder="Ej: Cra 15 #45-20, Apto 301"
              autocomplete="street-address"
              maxlength="120"
            />
            <span class="modal-field-error" id="error-address">Ingresa tu dirección completa</span>
          </div>

          <!-- Método de pago (solo Contraentrega) -->
          <div class="modal-form-group">
            <input type="hidden" name="paymentMethod" value="contraentrega" />
          </div>

          <!-- Botón enviar -->
          <button type="submit" id="modal-submit-btn">
            🚚 Confirmar Pedido Contra Entrega
          </button>

          <!-- Loading -->
          <div class="modal-loading" id="modal-loading">
            <div class="modal-spinner"></div>
            <span>Estamos registrando tu pedido...</span>
          </div>

          <!-- Error global -->
          <div id="modal-error-msg"></div>

        </form>
      </div>
    </div>
  `;

  // =============================================
  // VARIABLES DE ESTADO
  // =============================================
  let currentVariantId = null;
  let currentProductTitle = '';
  let isSubmitting = false;

  // =============================================
  // INICIALIZACIÓN
  // =============================================
  function init() {
    // Inyectar estilos
    const styleEl = document.createElement('style');
    styleEl.id = 'shopify-modal-styles';
    styleEl.textContent = MODAL_STYLES;
    document.head.appendChild(styleEl);

    // Inyectar HTML del modal
    const modalContainer = document.createElement('div');
    modalContainer.innerHTML = MODAL_HTML;
    document.body.appendChild(modalContainer);

    // Vincular eventos
    bindEvents();

    // Interceptar botones de compra
    interceptBuyButtons();

    console.log('[Modal] ✅ Pre-checkout modal inicializado');
  }

  // =============================================
  // INTERCEPTAR BOTONES DE COMPRA
  // =============================================
  function interceptBuyButtons() {
    const selectors = CONFIG.BUY_BUTTON_SELECTORS.join(', ');

    // Interceptar botones "Agregar al carrito" existentes
    document.querySelectorAll(selectors).forEach(btn => {
      attachModalToButton(btn);
    });

    // Reemplazar el botón "Comprar ahora" (Dynamic Checkout) de Shopify
    // Este botón usa un iframe interno que no se puede interceptar con JS normal,
    // por eso lo ocultamos con CSS y ponemos nuestro propio botón.
    injectBuyNowButton();

    // Observar botones que se agreguen dinámicamente (ej: temas con lazy load)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const btns = node.matches?.(selectors)
              ? [node]
              : [...(node.querySelectorAll?.(selectors) || [])];
            btns.forEach(attachModalToButton);

            // Si se agrega el contenedor del Dynamic Checkout, inyectar nuestro botón
            if (
              node.querySelector?.('.shopify-payment-button') ||
              node.classList?.contains('shopify-payment-button')
            ) {
              injectBuyNowButton();
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Inyecta un botón "Comprar ahora" personalizado junto al formulario del producto.
   * Reemplaza visualmente el Dynamic Checkout Button de Shopify.
   */
  function injectBuyNowButton() {
    // Evitar duplicar el botón
    if (document.getElementById('modal-buy-now-btn')) return;

    // Buscar el contenedor del Dynamic Checkout Button para insertar nuestro botón después
    const dynamicCheckoutContainers = [
      '.shopify-payment-button',
      '[data-shopify="payment-button"]',
      '.product-form__payment-button',
      '.product-form__buttons'  // fallback: junto a los botones del formulario
    ];

    let insertAfterEl = null;
    for (const sel of dynamicCheckoutContainers) {
      insertAfterEl = document.querySelector(sel);
      if (insertAfterEl) break;
    }

    if (!insertAfterEl) {
      // Si no encontramos el contenedor, buscar el botón add-to-cart como referencia
      insertAfterEl = document.querySelector(CONFIG.BUY_BUTTON_SELECTORS.join(', '));
    }

    if (!insertAfterEl) {
      console.warn('[Modal] No se encontró dónde insertar el botón "Comprar ahora"');
      return;
    }

    // Crear nuestro botón personalizado
    const btn = document.createElement('button');
    btn.id = 'modal-buy-now-btn';
    btn.className = 'modal-buy-now-btn';
    btn.type = 'button';
    btn.textContent = '🚚 Pedir Contra Entrega';

    // Insertar después del contenedor del Dynamic Checkout
    insertAfterEl.insertAdjacentElement('afterend', btn);

    // Adjuntar el modal a este botón
    attachModalToButton(btn);

    console.log('[Modal] Botón "Comprar ahora" personalizado inyectado');
  }

  /**
   * Adjunta el interceptor de modal a un botón
   * @param {HTMLElement} btn
   */
  function attachModalToButton(btn) {
    // Evitar duplicar listeners
    if (btn.dataset.modalAttached) return;
    btn.dataset.modalAttached = 'true';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Obtener variant_id
      const variantId = getVariantId();

      if (!variantId) {
        console.warn('[Modal] No se pudo obtener el variant_id del producto');
        // Si no hay variant_id, dejar pasar el click normal
        btn.dataset.modalAttached = '';
        btn.click();
        return;
      }

      currentVariantId = variantId;
      currentProductTitle = getProductTitle();

      console.log(`[Modal] Abriendo modal para variant_id: ${variantId}`);
      openModal();
    });
  }

  /**
   * Obtiene el variant_id del producto actual
   * @returns {string|null}
   */
  function getVariantId() {
    // 1. Buscar en selectores estándar de Shopify
    for (const selector of CONFIG.VARIANT_SELECTORS) {
      const el = document.querySelector(selector);
      if (el && el.value) {
        return el.value;
      }
    }

    // 2. Buscar en data attributes
    const variantEl = document.querySelector('[data-variant-id]');
    if (variantEl) {
      return variantEl.dataset.variantId;
    }

    // 3. Buscar en la URL (páginas de producto)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('variant')) {
      return urlParams.get('variant');
    }

    // 4. Buscar en el JSON del producto (Shopify lo inyecta en algunas páginas)
    try {
      const productJson = document.querySelector('[data-product-json]');
      if (productJson) {
        const product = JSON.parse(productJson.textContent);
        return product.variants?.[0]?.id?.toString();
      }
    } catch (e) {
      // Ignorar errores de parsing
    }

    return null;
  }

  /**
   * Obtiene el título del producto
   * @returns {string}
   */
  function getProductTitle() {
    const selectors = [
      '.product__title',
      '.product-single__title',
      'h1.title',
      '[data-product-title]',
      'h1'
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.textContent.trim()) {
        return el.textContent.trim();
      }
    }
    return document.title || '';
  }

  // =============================================
  // ABRIR / CERRAR MODAL
  // =============================================
  function openModal() {
    const overlay = document.getElementById('shopify-modal-overlay');
    if (!overlay) return;

    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Track InitiateCheckout
    trackPixelEvent('InitiateCheckout', {
      content_name: currentProductTitle || document.title,
      currency: 'COP'
    });

    // Focus en el primer campo
    setTimeout(() => {
      document.getElementById('modal-name')?.focus();
    }, 100);
  }

  function closeModal() {
    const overlay = document.getElementById('shopify-modal-overlay');
    if (!overlay) return;

    overlay.classList.remove('active');
    document.body.style.overflow = '';

    // Limpiar formulario y errores
    resetForm();
  }

  function resetForm() {
    const form = document.getElementById('shopify-modal-form');
    if (form) form.reset();

    // Limpiar errores
    document.querySelectorAll('.modal-field-error').forEach(el => {
      el.classList.remove('visible');
    });
    document.querySelectorAll('.modal-form-group input, .modal-form-group select').forEach(el => {
      el.classList.remove('error');
    });

    // Ocultar loading y error global
    setLoading(false);
    hideError();
  }

  // =============================================
  // VINCULAR EVENTOS
  // =============================================
  function bindEvents() {
    // Cerrar con botón X
    document.getElementById('shopify-modal-close')?.addEventListener('click', closeModal);

    // Cerrar al hacer click en el overlay (fuera del modal)
    // Solo cerrar si el clic empieza Y termina en el overlay (evita cierres accidentales al seleccionar texto)
    let mousedownTarget = null;
    const overlay = document.getElementById('shopify-modal-overlay');

    overlay?.addEventListener('mousedown', function (e) {
      mousedownTarget = e.target;
    });

    overlay?.addEventListener('click', function (e) {
      if (e.target === this && mousedownTarget === this) {
        closeModal();
      }
    });

    overlay?.addEventListener('mouseup', function () {
      mousedownTarget = null;
    });

    // Cerrar con tecla Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const overlay = document.getElementById('shopify-modal-overlay');
        if (overlay?.classList.contains('active')) closeModal();
      }
    });

    // Submit del formulario
    document.getElementById('shopify-modal-form')?.addEventListener('submit', handleSubmit);
  }

  // =============================================
  // ANALÍTICA (FACEBOOK PIXEL, ETC)
  // =============================================
  function trackPixelEvent(eventName, params = {}) {
    if (typeof window.fbq === 'function') {
      console.log(`[Pixel] Tracking: ${eventName}`, params);
      window.fbq('track', eventName, params);
    } else {
      console.warn('[Pixel] fbq no encontrado. Asegúrate de que el Píxel de Facebook esté instalado.');
    }
  }
  // =============================================
  // VALIDACIÓN
  // =============================================
  function validateForm(data) {
    const errors = {};

    if (!data.customerName || data.customerName.trim().length < 3) {
      errors.name = 'Por favor, escribe tu nombre completo para el envío';
    }

    if (!data.customerPhone || !/^\+?[\d\s\-()]{7,15}$/.test(data.customerPhone)) {
      errors.phone = 'Revisa tu teléfono, asegúrate que esté bien escrito';
    }

    if (!data.customerCity || data.customerCity.trim().length < 2) {
      errors.city = 'Ingresa el nombre de tu ciudad para la entrega';
    }

    if (!data.customerDepartment || data.customerDepartment.trim().length < 2) {
      errors.department = 'Revisa el departamento, asegúrate que esté bien escrito';
    }

    if (!data.customerAddress || data.customerAddress.trim().length < 5) {
      errors.address = 'Escribe tu dirección exacta (calle, número, apto)';
    }

    return errors;
  }

  function showFieldError(fieldId, message) {
    const input = document.getElementById(`modal-${fieldId}`);
    const errorEl = document.getElementById(`error-${fieldId}`);

    if (input) input.classList.add('error');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.add('visible');
    }
  }

  function clearFieldError(fieldId) {
    const input = document.getElementById(`modal-${fieldId}`);
    const errorEl = document.getElementById(`error-${fieldId}`);

    if (input) input.classList.remove('error');
    if (errorEl) errorEl.classList.remove('visible');
  }

  // =============================================
  // ESTADOS DE UI
  // =============================================
  function setLoading(loading) {
    isSubmitting = loading;
    const btn = document.getElementById('modal-submit-btn');
    const loadingEl = document.getElementById('modal-loading');
    const form = document.getElementById('shopify-modal-form');

    if (loading) {
      btn.style.display = 'none';
      loadingEl.classList.add('active');
      // Deshabilitar inputs
      form.querySelectorAll('input, select, button').forEach(el => el.disabled = true);
    } else {
      btn.style.display = 'block';
      loadingEl.classList.remove('active');
      form.querySelectorAll('input, select, button').forEach(el => el.disabled = false);
    }
  }

  function showError(message) {
    const errorEl = document.getElementById('modal-error-msg');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.add('visible');
    }
  }

  function hideError() {
    const errorEl = document.getElementById('modal-error-msg');
    if (errorEl) errorEl.classList.remove('visible');
  }

  // =============================================
  // ENVÍO DEL FORMULARIO
  // =============================================
  async function handleSubmit(e) {
    e.preventDefault();

    if (isSubmitting) return;

    // Limpiar errores previos
    ['name', 'phone', 'city', 'department', 'address'].forEach(clearFieldError);
    hideError();

    // Recopilar datos del formulario
    const formData = new FormData(e.target);
    const data = {
      customerName: formData.get('customerName')?.trim(),
      customerPhone: formData.get('customerPhone')?.trim(),
      customerCity: formData.get('customerCity')?.trim(),
      customerDepartment: formData.get('customerDepartment')?.trim(),
      customerAddress: formData.get('customerAddress')?.trim(),
      paymentMethod: formData.get('paymentMethod') || 'contraentrega',
      variantId: currentVariantId,
      quantity: 1,
      productTitle: currentProductTitle
    };

    console.log('[Modal] Datos del formulario:', data);

    // Validar
    const errors = validateForm(data);

    if (Object.keys(errors).length > 0) {
      Object.entries(errors).forEach(([field, message]) => {
        showFieldError(field, message);
      });
      return;
    }

    // Verificar variant_id
    if (!data.variantId) {
      showError('Error: No se pudo identificar el producto. Por favor recarga la página.');
      return;
    }

    // Mostrar loading
    setLoading(true);

    try {
      console.log('[Modal] Enviando pedido al backend...');

      const response = await fetch(`${CONFIG.BACKEND_URL}/create-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': '1'
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();
      console.log('[Modal] Respuesta del backend:', result);

      if (result.success) {
        // ✅ Pedido creado exitosamente
        console.log(`[Modal] ✅ Pedido #${result.order.order_number} creado`);

        // Track Purchase
        trackPixelEvent('Purchase', {
          value: parseFloat(result.order.total_price),
          currency: result.order.currency || 'COP',
          content_name: currentProductTitle,
          content_type: 'product',
          content_ids: [currentVariantId]
        });

        // Redirigir a página de gracias (con WhatsApp si está disponible)
        if (result.whatsapp_url) {
          // Abrir WhatsApp en nueva pestaña
          window.open(result.whatsapp_url, '_blank', 'noopener,noreferrer');
        }

        // Redirigir a página de gracias
        setTimeout(() => {
          if (result.redirect_url) {
            // Si la URL es absoluta (Shopify), ir directamente
            if (result.redirect_url.startsWith('http')) {
              window.location.href = result.redirect_url;
            } else {
              // Si es relativa, usar BACKEND_URL
              window.location.href = `${CONFIG.BACKEND_URL}${result.redirect_url}`;
            }
          } else {
            window.location.href = `${CONFIG.BACKEND_URL}/gracias`;
          }
        }, 500);

      } else {
        // ❌ Error del servidor
        const errorMsg = result.errors
          ? result.errors.join('. ')
          : (result.error || 'Error al procesar el pedido. Intenta de nuevo.');

        showError(errorMsg);
        setLoading(false);
      }

    } catch (error) {
      console.error('[Modal] Error de red:', error);
      showError('Error de conexión. Verifica tu internet e intenta de nuevo.');
      setLoading(false);
    }
  }

  // =============================================
  // ARRANCAR CUANDO EL DOM ESTÉ LISTO
  // =============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(); // IIFE - Evita contaminar el scope global
